import { ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ImageModule } from 'Angular/features/directives/image/image.module';
import { SupportCategoryPageComponent } from './components/support-category-page/support-category-page.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(SupportCategoryPageComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        IconModule,
        ImageModule,
        NavigationModule,
        ModalBaseModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
